import { IDynamicSize } from './types';

class dynamicSize implements IDynamicSize {
  convertSize = (size?: number) => {
    return size || 0;
  };
}

export default new dynamicSize();
